<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
      <md-button
        class="md-info md-sm small"
        @click="viewMode = 2"
        v-if="viewMode == 1"
      >
        상담사 캠페인
      </md-button>
      <md-button
        class="md-info md-sm small"
        @click="viewMode = 1"
        v-if="viewMode == 2"
      >
        상담사 캠페인 닫기
      </md-button>
    </h3>
    <!-- --------------------------- Modal Popup --------------------------------------->
    <vue-draggable-resizable
      :w="610"
      :h="855"
      :z="10"
      :parent="false"
      v-show="viewMode == 2"
      id="counselorCampaign"
    >
      <!-- todo 추 후 권한에 따라 렌더링 막아야 함. -->
      <div
        style="width: 100%; background: #fff; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: auto; box-sizing: border-box; padding: 10px;"
      >
        <!-- 상담사 캠페인 -->
        <counselor-campaign
          :view-mode.sync="viewMode"
          :is-comp="true"
          @memberSelected="campaignMemberChange"
          @callingCallback="callingCallback"
          ref="counselorCampaign"
        ></counselor-campaign>
        <!-- //상담사 캠페인 -->
      </div>
    </vue-draggable-resizable>

    <div class="md-layout">
      <!-- 개인 정보 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>person</md-icon>개인정보
            <md-button
              class="md-info md-sm small"
              type="button"
              @click="saveBasicInfo"
              style="margin-top: -2px; margin-left: 3px; vertical-align: middle;"
              :disabled="!profile.printingGb"
            >
              <md-icon>check</md-icon>저장
            </md-button>
            <md-button
              class="md-info md-sm small"
              type="button"
              @click="
                event => {
                  if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                  }
                  this.setSms();
                }
              "
              :disabled="!profile.printingGb"
              style="margin-right: 50px;"
            >
              <md-icon>check</md-icon>메세지 전송
            </md-button>
            <span v-show="profile.printingGb != null">
              {{ profile.memberHnm }}
              [{{ profile.memberNo }}]
              {{ profile.statusCdNm }}
              <span v-show="familyData.length" style="font-size: 12px;">
                가족교우 :
                <span v-for="(item, index) in familyData">
                  {{ index > 0 ? ", " : "" }}
                  {{
                    item.sMemberNo == profile.memberNo
                      ? item.mMemberHnm
                      : item.sMemberHnm
                  }}
                  ({{
                    item.sMemberNo == profile.memberNo
                      ? item.mMemberNo
                      : item.sMemberNo
                  }})
                </span>
              </span>
            </span>
            <div
              class="header-info"
              v-if="profile.memberUpdateDate && profile.memberUpdateDate != ''"
            >
              최종 변경일 : {{ profile.memberUpdateDate }}
            </div>
          </h4>
        </md-card-header>

        <ValidationObserver ref="saveBasicInfoForm">
          <form @submit.prevent="saveBasicInfo">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-10 no-padding">
                  <div class="photo-frame">
                    <img v-bind:src="savedImgUrl" />
                  </div>
                  <div class="photo-ui flex-div">
                    <input
                      type="file"
                      class="hidden-input-file"
                      id="photoFileInput"
                      accept=".jpeg,.jpg,.gif"
                    />
                    <!-- 사진을 등록해야 하는 경우-->
                    <div class="inline-flex">
                      <input
                        type="text"
                        disabled
                        placeholder="사진파일 선택"
                        v-model="photoFileName"
                      />
                      <span
                        type="button"
                        @click="onClickSearchProfilePhoto"
                        style="cursor: pointer"
                      >
                        <md-icon>search</md-icon>
                      </span>
                      <input
                        name="photoFileSize"
                        type="hidden"
                        v-model="photoFileSize"
                      />
                    </div>
                  </div>
                  <textarea
                    v-model="profile.remark"
                    class="remark-input"
                  ></textarea>
                </div>
                <div class="md-layout-item md-size-90 no-padding">
                  <table class="flex-table">
                    <tr>
                      <th>교우명</th>
                      <td>
                        <ValidationProvider
                          name="profile.memberHnm"
                          :rules="{ required: true }"
                        >
                          <div class="inline-flex">
                            <input type="text" v-model="profile.memberHnm" />
                            <button
                              @click="
                                event => {
                                  if (event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                  }
                                  this.memberModalMode = 'profile';
                                  this.isShowMemberModal = true;
                                }
                              "
                            >
                              <md-icon>search</md-icon>
                            </button>
                          </div>
                        </ValidationProvider>
                      </td>
                      <th>휴대폰</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            v-model="profile.cellular"
                            v-mask-phone-number
                          />
                          <label
                            ><input
                              type="checkbox"
                              true-value="Y"
                              false-value="N"
                              v-model="profile.cellularDeny"
                          /></label>
                        </div>
                      </td>
                      <th>단과대학</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            disabled
                            v-model="searchedCollegeName"
                          />
                          <input type="hidden" v-model="profile.collegeCd" />
                          <!--                          <button v-on:click="activateShowCollegeModal">-->
                          <!--                            <md-icon>search</md-icon>-->
                          <!--                          </button>-->
                        </div>
                      </td>
                      <th style="background: #00ffff">평생회비</th>
                      <td style="background: #00ffff">
                        {{ profile.memberGb }}
                      </td>
                      <th>개명전</th>
                      <td>
                        <input type="text" v-model="profile.prevNm" />
                      </td>
                    </tr>
                    <tr>
                      <th>교우번호</th>
                      <td>
                        <ValidationProvider
                          name="profile.memberNo"
                          :rules="{
                            required: true,
                            regex: /^[a-zA-Z0-9]*$/,
                            min: 8
                          }"
                        >
                          <div class="inline-flex">
                            <input
                              v-focus
                              type="text"
                              v-model="profile.memberNo"
                              v-on:keydown.enter.stop="searchMemberInfoByNo"
                              maxlength="8"
                            />
                            <button
                              @click.stop="searchMemberInfoByNo"
                              style="padding-left: 5px;"
                            >
                              go
                            </button>
                          </div>
                        </ValidationProvider>
                      </td>
                      <th>이메일 1</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" v-model="profile.eMail" />
                          <label
                            ><input
                              type="checkbox"
                              true-value="Y"
                              false-value="N"
                              v-model="profile.eMailDeny"
                          /></label>
                        </div>
                      </td>
                      <th>학과</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            disabled
                            v-model="searchedClassName"
                          />
                          <input type="hidden" v-model="profile.classCd" />
                          <!--                          <button v-on:click="activateShowDeptModal">-->
                          <!--                            <md-icon>search</md-icon>-->
                          <!--                          </button>-->
                        </div>
                      </td>
                      <th>회비등급</th>
                      <td>
                        <input type="text" v-model="profile.feeLevelCdNm" />
                      </td>
                      <th>한자명</th>
                      <td>
                        <input type="text" v-model="profile.memberCnm" />
                      </td>
                    </tr>
                    <tr>
                      <th>생년월일</th>
                      <td>
                        <input
                          type="text"
                          v-model="profile.birthday"
                          v-mask="'####-##-##'"
                        />
                      </td>
                      <th>이메일 2</th>
                      <td>
                        <div class="inline-flex">
                          <input type="text" v-model="profile.eMail2" />
                          <label
                            ><input
                              type="checkbox"
                              true-value="Y"
                              false-value="N"
                              v-model="profile.eMail2Deny"
                          /></label>
                        </div>
                      </td>
                      <th>학번</th>
                      <td>
                        <input type="text" disabled v-model="profile.hakbun" />
                      </td>
                      <th>최종납입년</th>
                      <td>
                        {{ profile.lastFeeYear }}
                      </td>
                      <th>영문명</th>
                      <td>
                        <input type="text" v-model="profile.memberEnm" />
                      </td>
                    </tr>
                    <tr>
                      <th>성별</th>
                      <td>
                        <!--                        <ValidationProvider name="profile.sex" :rules="{ required: true }">-->
                        <label>
                          <input
                            type="radio"
                            value="M"
                            v-model="profile.sex"
                          />남
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="F"
                            v-model="profile.sex"
                          />여
                        </label>
                        <!--                        </ValidationProvider>-->
                      </td>
                      <th>웹ID</th>
                      <td>
                        <input type="text" v-model="profile.webid" />
                      </td>
                      <th>회원등급</th>
                      <td>
                        <select v-model="profile.mlevelCd">
                          <option value="">- 선택 -</option>
                          <option
                            v-for="item in memberLevelTypeList"
                            :key="item.code"
                            :label="item.codeNm"
                            :value="item.code"
                          ></option>
                        </select>
                      </td>
                      <th>최종납입일</th>
                      <td>
                        {{ profile.lastFeeDate }}
                      </td>
                      <th>국적</th>
                      <td>
                        <div class="inline-flex">
                          <input
                            type="text"
                            disabled
                            v-model="searchedNationalName"
                          />
                          <input type="hidden" v-model="profile.nationalCd" />
                          <button
                            v-on:click="
                              activateShowNationalModal('profile', $event)
                            "
                          >
                            <md-icon>search</md-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>교우직위</th>
                      <td>
                        {{ profile.memberorgGbNm }}
                      </td>
                      <th>웹가입일자</th>
                      <td>
                        <input
                          type="text"
                          disabled
                          v-model="profile.webjoinDate"
                        />
                      </td>
                      <th>교원 구분</th>
                      <td>
                        <select v-model="profile.staffCd">
                          <option value="">- 교원 아님 -</option>
                          <option
                            v-for="item in staffTypeList"
                            :key="item.code"
                            :label="item.codeNm"
                            :value="item.code"
                          >
                          </option>
                        </select>
                      </td>
                      <th>출신고교</th>
                      <td>
                        <input type="text" v-model="profile.highschool" />
                      </td>
                      <th>본적</th>
                      <td>
                        <select v-model="profile.bornCd">
                          <option value="">- 선택 -</option>
                          <option
                            v-for="item in bornCdList"
                            :key="item.code"
                            :label="item.codeNm"
                            :value="item.code"
                          ></option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th rowspan="2">단체관리</th>
                      <td colspan="5" rowspan="2">
                        <div class="branch-list branch-list2">
                          <div class="branch-list-con">
                            <div
                              class="item"
                              v-for="item in branchMemberList"
                              v-bind:key="item.branchNm"
                            >
                              {{ item.branchNm }}, {{ item.positionNm }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <th rowspan="2">업무용 소모임</th>
                      <td rowspan="2">
                        <div class="branch-list">
                          <div
                            class="item"
                            v-for="item in branchZMemberList"
                            v-bind:key="item.branchNm"
                          >
                            {{ item.branchNm }}
                          </div>
                        </div>
                      </td>
                      <th style="background: #00ffff">우편물 수령처</th>
                      <td>
                        <select
                          v-model="profile.postplace"
                          @change="changeNonpostGb($event)"
                          style="background: #00ffff"
                        >
                          <option value="">- 선택 -</option>
                          <option
                            v-for="item in postReceiptTypeList"
                            :key="item.code"
                            :label="item.codeNm"
                            :value="item.code"
                          ></option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th style="background: #00ffff">미발송 사유</th>
                      <td>
                        <select
                          v-model="profile.nonpostGb"
                          @change="changeNonPostReceiptType"
                          style="background: #00ffff"
                        >
                          <option value="">- 선택 -</option>
                          <option
                            v-for="item in nonPostReceiptTypeList"
                            :key="item.code"
                            :label="item.codeNm"
                            :value="item.code"
                          ></option>
                        </select>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </md-card-content>
          </form>
        </ValidationObserver>
      </md-card>

      <div style="width: 100%;">
        <!-- 주소 정보 시작 -->
        <md-card>
          <ValidationObserver ref="saveDetailInfoForm">
            <form @submit.prevent="saveDetailInfo">
              <md-card-header md-alignment="space-between">
                <h4 class="title">
                  <md-icon>person</md-icon>
                  주소정보
                  <md-button
                    class="md-info md-sm small"
                    type="submit"
                    style="margin-top: -2px; margin-left: 3px; vertical-align: middle;"
                  >
                    <md-icon>check</md-icon>
                    저장
                  </md-button>
                  <div class="header-info">
                    <button
                      class="btn-in-title"
                      @click="
                        event => {
                          if (event) {
                            event.stopPropagation();
                            event.preventDefault();
                          }
                          this.isShowAddressCard = !this.isShowAddressCard;
                          this.showAddresType = 1;
                        }
                      "
                    >
                      주소 정보 {{ this.isShowAddressCard ? "닫기" : "보기" }}
                    </button>
                    <span
                      v-if="
                        profile.addrUpdateDate && profile.addrUpdateDate != ''
                      "
                      >최종 변경일 : {{ profile.addrUpdateDate }}</span
                    >
                  </div>
                </h4>
              </md-card-header>
              <div class="md-group tab-area" v-if="isShowAddressCard">
                <md-button class="md-default" @click="showAddresType = 1"
                  >국내</md-button
                >
                <md-button class="md-default" @click="showAddresType = 2"
                  >해외</md-button
                >
              </div>
              <md-card-content v-if="isShowAddressCard">
                <div class="md-layout md-size-100" v-show="showAddresType == 1">
                  <div class="md-layout-item md-size-40 no-padding">
                    <h4 class="margin-0" style="position: relative">
                      국내 거주지
                      <span
                        class="update-date"
                        v-if="profile.hUpdateDate && profile.hUpdateDate != ''"
                        >변경일자 : {{ profile.hUpdateDate }}</span
                      >
                      <md-button
                        class="md-default md-sm"
                        style="position: absolute; top: -10px; right: 0px;"
                        @click="clearAddress"
                      >
                        <md-icon>clear</md-icon>초기화
                      </md-button>
                    </h4>
                    <table class="flex-table">
                      <tr>
                        <th>주소</th>
                        <td colspan="3">
                          <table class="table-in-td">
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.homeZipcd"
                                  class="w70"
                                  disabled
                                  placeholder="우편번호"
                                />
                                <button
                                  v-on:click="addressModalOpen('1', $event)"
                                >
                                  <md-icon>search</md-icon>
                                  검색
                                </button>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="N"
                                    false-value="Y"
                                    v-model="profile.homeStatus"
                                  />반송
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="profile.homeAddressDeny"
                                  />정보공개거부
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.homeAddress1"
                                  disabled
                                  placeholder="기본주소"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  ref="homeAddress2Input"
                                  v-model="profile.homeAddress2"
                                  placeholder="상세주소"
                                />
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <th>전화번호</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              v-model="profile.homeTel"
                              v-mask-phone-number
                            />
                          </div>
                        </td>
                        <th>기타연락처</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              v-model="profile.homeFax"
                              v-mask-phone-number
                            />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item md-size-60 no-padding">
                    <h4 class="margin-0">
                      국내 직장주소
                      <span
                        class="update-date"
                        v-if="profile.oUpdateDate && profile.oUpdateDate != ''"
                        >변경일자 : {{ profile.oUpdateDate }}</span
                      >
                      <md-button
                        class="md-default md-sm"
                        style="position: absolute; top: 0; right: 310px;"
                        @click="clearWorkAddress"
                      >
                        <md-icon>clear</md-icon>초기화
                      </md-button>
                      <md-button
                        class="md-default md-sm"
                        style="position: absolute; top: 0; right: 125px;"
                        @click="clearwork"
                      >
                        <md-icon>clear</md-icon>초기화
                      </md-button>
                      <md-button
                        class="md-default md-sm"
                        style="position: absolute; top: 0; right: 10px;"
                        @click="resignation"
                      >
                        <md-icon>clear</md-icon>
                        퇴사처리
                      </md-button>
                    </h4>
                    <table class="flex-table">
                      <tr>
                        <th rowspan="3">주소</th>
                        <td colspan="3" rowspan="3">
                          <table class="table-in-td">
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.officeZipcd"
                                  class="w70"
                                  disabled
                                  placeholder="우편번호"
                                />
                                <button
                                  v-on:click="addressModalOpen('2', $event)"
                                >
                                  <md-icon>search</md-icon>
                                  검색
                                </button>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="N"
                                    false-value="Y"
                                    v-model="profile.officeStatus"
                                  />반송
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="profile.officeAddressDeny"
                                  />정보공개거부
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.officeAddress1"
                                  disabled
                                  placeholder="기본주소"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  ref="officeAddress2Input"
                                  v-model="profile.officeAddress2"
                                  placeholder="상세주소"
                                />
                              </td>
                            </tr>
                          </table>
                        </td>
                        <th>직종</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              disabled
                              v-model="profile.workCd1Nm"
                            />
                            <button
                              @click="
                                event => {
                                  if (event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                  }
                                  this.isShowWorkModal1 = true;
                                }
                              "
                            >
                              <md-icon>search</md-icon>
                            </button>
                            <input
                              type="text"
                              disabled
                              v-model="profile.workCd2Nm"
                            />
                            <button
                              @click="
                                event => {
                                  if (event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                  }
                                  this.isShowWorkModal2 = true;
                                }
                              "
                            >
                              <md-icon>search</md-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>직장명</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              disabled
                              v-model="profile.companyNm"
                            />
                            <button
                              @click="
                                event => {
                                  if (event) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                  }
                                  this.isShowCompanyModal = true;
                                }
                              "
                            >
                              <md-icon>search</md-icon>
                            </button>
                            <!--                            <select v-model="profile.workhisGb">-->
                            <!--                          		<option v-for="item in memberWorkHisGb" :key="item.code" :label="item.codeNm" :value="item.code"></option>-->
                            <!--                          	</select>-->
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>부서</th>
                        <td>
                          <input type="text" v-model="profile.partNm" />
                        </td>
                      </tr>
                      <tr>
                        <th>대표전화번호</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              v-model="profile.officeTel"
                              v-mask-phone-number
                            />
                          </div>
                        </td>
                        <th>FAX번호</th>
                        <td>
                          <div class="inline-flex">
                            <input
                              type="text"
                              v-model="profile.officeFax"
                              v-mask-phone-number
                            />
                          </div>
                        </td>
                        <th>직위</th>
                        <td>
                          <input type="text" v-model="profile.levelNm" />
                        </td>
                      </tr>
                      <tr>
                        <!--                        <th>연락담당자</th>
                        <td><input type="text" v-mask-phone-number/></td>
                        <th>담당번호</th>
                        <td><input type="text" v-mask-phone-number/></td>
-->
                        <th colspan="5" align="right">
                          직책&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </th>
                        <td>
                          <input type="text" v-model="profile.positionNm" />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div class="md-layout md-size-100" v-show="showAddresType == 2">
                  <div class="md-layout-item md-size-40 no-padding">
                    <h4 class="margin-0">
                      해외 거주지
                      <span
                        class="update-date"
                        v-if="
                          profile.ahUpdateDate && profile.ahUpdateDate != ''
                        "
                        >변경일자 : {{ profile.ahUpdateDate }}</span
                      >
                    </h4>
                    <table class="flex-table">
                      <tr>
                        <th>주소</th>
                        <td colspan="3">
                          <table class="table-in-td">
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="searchedAhomeAddressNationalName"
                                  class="w200"
                                />
                                <button
                                  @click="
                                    activateShowNationalModal(
                                      'ahomeAddress',
                                      $event
                                    )
                                  "
                                >
                                  <md-icon>search</md-icon>
                                </button>
                                국가 검색
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="N"
                                    false-value="Y"
                                    v-model="profile.ahomeStatus"
                                  />반송
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="profile.ahomeAddressDeny"
                                  />정보공개거부
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.ahomeAddress1"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.ahomeAddress2"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.ahomeAddress3"
                                />
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <th>전화번호</th>
                        <td>
                          <div class="inline-flex">
                            <input type="text" v-model="profile.ahomeTel" />
                          </div>
                        </td>
                        <th>FAX번호</th>
                        <td>
                          <div class="inline-flex">
                            <input type="text" v-model="profile.ahomeFax" />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="md-layout-item md-size-60 no-padding">
                    <h4 class="margin-0">
                      해외 직장주소
                      <span
                        class="update-date"
                        v-if="
                          profile.aoUpdateDate && profile.aoUpdateDate != ''
                        "
                        >변경일자 : {{ profile.aoUpdateDate }}</span
                      >
                    </h4>
                    <table class="flex-table">
                      <tr>
                        <th>주소</th>
                        <td colspan="3">
                          <table class="table-in-td">
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  class="w200"
                                  v-model="searchedAofficeAddressNationalName"
                                />
                                <button
                                  @click="
                                    activateShowNationalModal(
                                      'aofficeAddress',
                                      $event
                                    )
                                  "
                                >
                                  <md-icon>search</md-icon>
                                </button>
                                국가 검색
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="N"
                                    false-value="Y"
                                    v-model="profile.aofficeStatus"
                                  />반송
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    true-value="Y"
                                    false-value="N"
                                    v-model="profile.aofficeAddressDeny"
                                  />정보공개거부
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.aofficeAddress1"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.aofficeAddress2"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <input
                                  type="text"
                                  v-model="profile.aofficeAddress3"
                                />
                              </td>
                            </tr>
                          </table>
                        </td>
                        <th></th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>전화번호</th>
                        <td>
                          <div class="inline-flex">
                            <input type="text" v-model="profile.aofficeTel" />
                          </div>
                        </td>
                        <th>FAX번호</th>
                        <td>
                          <div class="inline-flex">
                            <input type="text" v-model="profile.aofficeFax" />
                          </div>
                        </td>
                        <th></th>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </md-card-content>
              <!--            <md-card-actions md-alignment="right" v-if="isShowAddressCard">-->
              <!--              <md-button class="md-info md-sm" type="submit">-->
              <!--                <md-icon>check</md-icon>-->
              <!--                저장-->
              <!--              </md-button>-->
              <!--            </md-card-actions>-->
            </form>
          </ValidationObserver>
        </md-card>

        <!-- 이력사항 시작 -->
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>history</md-icon>
              이력 사항
              <div
                class="header-info"
                v-if="profile.updateDate && profile.updateDate != ''"
              >
                최종 변경일 : {{ profile.scholarUpdateDate }}
              </div>
            </h4>
          </md-card-header>
          <div class="md-group tab-area">
            <md-button class="md-default md-white" @click="onClickTab(1)"
              >학력사항</md-button
            >
            <md-button class="md-default" @click="onClickTab(2)"
              >직장이력</md-button
            >
            <md-button class="md-default" @click="onClickTab(3)"
              >주소이력</md-button
            >
            <md-button class="md-default" @click="onClickTab(4)"
              >회비내역</md-button
            >
            <md-button class="md-default" @click="onClickTab(5)"
              >임원이력</md-button
            >
            <md-button class="md-default" @click="onClickTab(6)"
              >경조사이력</md-button
            >
            <md-button class="md-default" @click="onClickTab(7)"
              >행사참여</md-button
            >
            <md-button class="md-default" @click="onClickTab(8)"
              >기부금(장학)</md-button
            >
            <md-button class="md-default" @click="onClickTab(9)"
              >장학금 수혜</md-button
            >
            <md-button class="md-default" @click="onClickTab(10)"
              >가족교우</md-button
            >
            <md-button class="md-default" @click="onClickTab(11)"
              >상담내역</md-button
            >
            <!-- <md-button class="md-default" @click="onClickTab(12)">의료 우대증</md-button> -->
            <!--            <md-button class="md-default" @click="onClickTab(3)">회비 개별 처리</md-button>-->
          </div>
          <div class="simple-tab-group">
            <div v-show="showTab === 1">
              <md-card-content>
                <md-table
                  :value="scholarHistoryData"
                  class="paginated-table table-striped table-hover text-align-center h-scroll h300"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    @click.native="selectScholarItem(item)"
                  >
                    <md-table-cell md-label="학위">{{
                      item.degreeCdNm
                    }}</md-table-cell>
                    <md-table-cell md-label="입학년월">{{
                      item.enterYm
                    }}</md-table-cell>
                    <md-table-cell md-label="졸업년월">{{
                      item.graduationYm
                    }}</md-table-cell>
                    <md-table-cell md-label="학번">{{
                      item.hakbun
                    }}</md-table-cell>
                    <md-table-cell md-label="졸업회수">{{
                      item.graduationNo
                    }}</md-table-cell>
                    <md-table-cell md-label="대학코드">{{
                      item.collegeCd
                    }}</md-table-cell>
                    <md-table-cell md-label="대학" style="text-align: left;">{{
                      item.collegeCdNm
                    }}</md-table-cell>
                    <md-table-cell md-label="학과코드">{{
                      item.classCd
                    }}</md-table-cell>
                    <md-table-cell md-label="학과" style="text-align: left;">{{
                      item.classCdNm
                    }}</md-table-cell>
                    <md-table-cell md-label="이중전공코드">{{
                      item.classSmajor
                    }}</md-table-cell>
                    <md-table-cell
                      md-label="이중전공"
                      style="text-align: left;"
                      >{{ item.classSmajorNm }}</md-table-cell
                    >
                    <md-table-cell
                      md-label="이중전공대학"
                      style="text-align: left;"
                      >{{ item.classSmajorCollege }}</md-table-cell
                    >
                    <md-table-cell md-label="출력">{{
                      item.printingGb
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
              <md-card-actions md-alignment="right">
                <md-button
                  class="md-info md-sm"
                  @click="addScholarItem"
                  v-if="userGroup == '3' || userGroup == '5'"
                >
                  <!--                <md-button class="md-info md-sm" @click="addScholarItem" v-if="userGroup == '3' || userGroup == '5' || userGroup == '2'">-->
                  <md-icon>check</md-icon>
                  신규
                </md-button>
              </md-card-actions>
            </div>
          </div>
          <div v-show="showTab === 2">
            <md-card-content>
              <md-table
                :value="workHistoryData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="변경사유">{{
                    item.workhisGbNm
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="직종대분류"
                    style="text-align: left;"
                    >{{ item.workCd1Nm }}</md-table-cell
                  >
                  <md-table-cell
                    md-label="직종소분류"
                    style="text-align: left;"
                    >{{ item.workCd2Nm }}</md-table-cell
                  >
                  <md-table-cell md-label="직장" style="text-align: left;">{{
                    item.companyIdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="부서" style="text-align: left;">{{
                    item.partNm
                  }}</md-table-cell>
                  <md-table-cell md-label="직위">{{
                    item.levelNm
                  }}</md-table-cell>
                  <md-table-cell md-label="직책">{{
                    item.positionNm
                  }}</md-table-cell>
                  <md-table-cell md-label="변경발생일시">{{
                    item.happenDate
                  }}</md-table-cell>
                  <md-table-cell md-label="생성일시">{{
                    item.insertDate
                  }}</md-table-cell>
                  <md-table-cell md-label="변경자">{{
                    item.userNm
                  }}</md-table-cell>
                  <!-- <md-table-cell md-label="삭제">
										<button class="btn-in-table" @click="removeJobHistory(item)">
											<md-icon>remove</md-icon>
										</button>
									</md-table-cell> -->
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 3">
            <md-card-content>
              <md-table
                :value="addressHistoryData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="주소구분">{{
                    item.addressGbNm
                  }}</md-table-cell>
                  <md-table-cell md-label="국가">{{
                    item.nationalCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="우편번호">{{
                    item.zipCd
                  }}</md-table-cell>
                  <md-table-cell md-label="주소" style="text-align: left;"
                    >{{ item.address1 }},{{ item.address2 }}</md-table-cell
                  >
                  <md-table-cell md-label="전화번호">{{
                    item.tel
                  }}</md-table-cell>
                  <md-table-cell md-label="FAX 번호">{{
                    item.fax
                  }}</md-table-cell>
                  <md-table-cell md-label="변경일시">{{
                    item.updateDate
                  }}</md-table-cell>
                  <md-table-cell md-label="변경자">{{
                    item.userNm
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 4">
            <md-card-content>
              <md-table
                :value="feeHistoryData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="회비년도">{{
                    item.feeYear
                  }}</md-table-cell>
                  <md-table-cell md-label="납부일자">{{
                    item.feeDate
                  }}</md-table-cell>
                  <md-table-cell md-label="금액" style="text-align: right;">{{
                    formatter.getCurrency(item.feeAmt)
                  }}</md-table-cell>
                  <md-table-cell md-label="회비구분">{{
                    item.feeCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="회비구분">{{
                    item.feeCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="회비등급">{{
                    item.feeLevelCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="납입구분">{{
                    item.feeGbNm
                  }}</md-table-cell>
                  <md-table-cell md-label="납부방법">{{
                    item.feeWayNm
                  }}</md-table-cell>
                  <md-table-cell md-label="납부은행">{{
                    item.bankCdNm
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="지부/분회/대학"
                    style="text-align: left;"
                    >{{ item.branchNm }}</md-table-cell
                  >
                  <md-table-cell md-label="입력일시">{{
                    item.insertDate
                  }}</md-table-cell>
                  <md-table-cell md-label="수정일시">{{
                    item.updateDate
                  }}</md-table-cell>
                  <md-table-cell md-label="비고" style="text-align: left;">{{
                    item.feeEtc
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="right">
              <md-button class="md-info md-sm" @click="payCard"
                ><md-icon>payment</md-icon>신용카드 결제</md-button
              >
            </md-card-actions>
          </div>
          <div v-show="showTab === 5">
            <md-card-content>
              <md-table
                :value="orgHistoryData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="취임일">{{
                    formatter.getDateFormat(item.erectDate)
                  }}</md-table-cell>
                  <md-table-cell md-label="퇴임일">{{
                    formatter.getDateFormat(item.expireDate)
                  }}</md-table-cell>
                  <md-table-cell md-label="직위">{{
                    item.levelCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="대수">{{
                    item.reign
                  }}</md-table-cell>
                  <md-table-cell md-label="추천코드">{{
                    item.branchId
                  }}</md-table-cell>
                  <md-table-cell md-label="추천명">{{
                    item.branchIdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="비고" style="text-align: left;">{{
                    item.remark
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 6">
            <md-card-content>
              <md-table
                :value="prizeHistoryData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="경조구분">{{
                    item.kyjoCdNm
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="기타행사"
                    style="text-align: left;"
                    >{{ item.prizeEtc }}</md-table-cell
                  >
                  <md-table-cell
                    md-label="접수내용"
                    style="text-align: left;"
                    >{{ item.remark }}</md-table-cell
                  >
                  <md-table-cell md-label="장소" style="text-align: left;">{{
                    item.place
                  }}</md-table-cell>
                  <md-table-cell md-label="행사일시">{{
                    item.useDate
                  }}</md-table-cell>
                  <md-table-cell md-label="조치">{{
                    item.actCdNm
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="리본내용"
                    style="text-align: left;"
                    >{{ item.ribbonCont }}</md-table-cell
                  >
                  <md-table-cell md-label="발송명의">{{
                    item.fromNm
                  }}</md-table-cell>
                  <md-table-cell md-label="의뢰" style="text-align: left;">{{
                    item.request
                  }}</md-table-cell>
                  <md-table-cell md-label="주문일자">{{
                    item.orderDate
                  }}</md-table-cell>
                  <md-table-cell md-label="업체" style="text-align: left;">{{
                    item.storeCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="금액" style="text-align: right;"
                    >{{ formatter.getCurrency(item.amt) }} 원</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 7">
            <md-card-content>
              <md-table
                :value="eventJoinerData"
                class="paginated-table table-striped table-hover text-align-center h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="시작일">{{
                    formatter.getDateFormat(item.eventBegin)
                  }}</md-table-cell>
                  <md-table-cell md-label="종료일">{{
                    formatter.getDateFormat(item.eventEnd)
                  }}</md-table-cell>
                  <md-table-cell md-label="행사명" style="text-align: left;">{{
                    item.eventTitle
                  }}</md-table-cell>
                  <md-table-cell md-label="행사구분">{{
                    item.eventCdNm
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="행사설명"
                    style="text-align: left;"
                    >{{ item.eventDesc }}</md-table-cell
                  >
                  <md-table-cell md-label="장소" style="text-align: left;">{{
                    item.eventPlace
                  }}</md-table-cell>
                  <md-table-cell md-label="비고" style="text-align: left;">{{
                    item.eventEtc
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 8">
            <md-card-content>
              <div class="md-layout md-size-100">
                <div class="md-layout-item md-size-40 no-padding">
                  <md-table
                    :value="donationList"
                    class="paginated-table table-striped table-hover text-align-center h-scroll h300"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="기부일자">{{
                        formatter.getDateFormat(item.depositDate)
                      }}</md-table-cell>
                      <md-table-cell
                        md-label="기부금액"
                        style="text-align: right;"
                        >{{ formatter.getCurrency(item.giveAmount) }} 원
                      </md-table-cell>
                      <md-table-cell md-label="지급학기">{{
                        item.semesterCdNm
                      }}</md-table-cell>
                      <md-table-cell md-label="비고">{{
                        item.agreemEtc
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                  <div
                    v-show="donationList.length > 0"
                    class="total-line left-type"
                  >
                    <span class="total-label">합계</span>
                    <span class="total-amount" style="text-align: right;">{{
                      donationSum
                    }}</span>
                    <span class="total-count" style="text-align: right;"
                      >({{ donationCount }}회)</span
                    >
                  </div>
                </div>
                <div class="md-layout-item md-size-60 no-padding">
                  <md-table
                    :value="applyDonationList"
                    class="paginated-table table-striped table-hover text-align-center h-scroll h300"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="지급학기">{{
                        item.semesterCdNm
                      }}</md-table-cell>
                      <md-table-cell md-label="교우번호">{{
                        item.applyMemberNo
                      }}</md-table-cell>
                      <md-table-cell
                        md-label="성명"
                        style="text-align: left;"
                        >{{ item.nm }}</md-table-cell
                      >
                      <md-table-cell md-label="생년월일">{{
                        formatter.getDateFormat(
                          item.bornYm.length == 6
                            ? item.bornYm.substring(0, 1) == "0"
                              ? "20" + item.bornYm
                              : "19" + item.bornYm
                            : item.bornYm
                        )
                      }}</md-table-cell>
                      <md-table-cell
                        md-label="대학"
                        style="text-align: left;"
                        >{{ item.collegeNm }}</md-table-cell
                      >
                      <md-table-cell
                        md-label="학과"
                        style="text-align: left;"
                        >{{ item.classNm }}</md-table-cell
                      >
                      <md-table-cell md-label="학번">{{
                        item.hakbun
                      }}</md-table-cell>
                      <md-table-cell md-label="학년">{{
                        item.collegeSemesterCdNm
                      }}</md-table-cell>
                      <md-table-cell
                        md-label="지급액"
                        style="text-align: right;"
                        >{{
                          formatter.getCurrency(
                            item.kuaaAmount +
                              item.schaAmount +
                              item.reserveAmount
                          )
                        }}
                        원
                      </md-table-cell>
                      <md-table-cell md-label="구분">{{
                        item.applyGbNm
                      }}</md-table-cell>
                      <md-table-cell md-label="비고" style="text-align: left;">
                        {{ item.etc }}</md-table-cell
                      >
                    </md-table-row>
                  </md-table>
                  <div
                    v-show="applyDonationList.length > 0"
                    class="total-line left-type"
                  >
                    <span class="total-label">합계</span>
                    <span class="total-amount" style="text-align: right;">{{
                      applyDonationSum
                    }}</span>
                    <span class="total-count" style="text-align: right;"
                      >({{ applyDonationCount }}명)</span
                    >
                  </div>
                </div>
              </div>
            </md-card-content>
          </div>
          <div v-show="showTab === 9">
            <md-card-content>
              <md-table
                :value="benefitDonationList"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="지급학기">{{
                    item.semesterCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="대학" style="text-align: left;">{{
                    item.collegeMCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="학과" style="text-align: left;">{{
                    item.collegeSCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="학번">{{
                    item.hakbun
                  }}</md-table-cell>
                  <md-table-cell md-label="학년">{{
                    item.collegeSemesterCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="지급액" style="text-align: right;"
                    >{{
                      item.kuaaAmount + item.schaAmount + item.reserveAmount
                    }}
                    원
                  </md-table-cell>
                  <md-table-cell md-label="구분">{{
                    item.applyGbNm
                  }}</md-table-cell>
                  <md-table-cell md-label="기부교우번호">{{
                    item.memberNo
                  }}</md-table-cell>
                  <md-table-cell
                    md-label="기부교우"
                    style="text-align: left;"
                    >{{ item.memberHnm }}</md-table-cell
                  >
                  <md-table-cell md-label="비고" style="text-align: left;">{{
                    item.applyEtc
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
          <div v-show="showTab === 10">
            <md-card-content>
              <md-table
                :value="familyData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="교우번호">{{
                    item.sMemberNo == profile.memberNo
                      ? item.mMemberNo
                      : item.sMemberNo
                  }}</md-table-cell>
                  <md-table-cell md-label="교우명">{{
                    item.sMemberNo == profile.memberNo
                      ? item.mMemberHnm
                      : item.sMemberHnm
                  }}</md-table-cell>
                  <md-table-cell md-label="생년월일">{{
                    item.sMemberNo == profile.memberNo
                      ? item.mBirthday
                      : item.sBirthday
                  }}</md-table-cell>
                  <md-table-cell md-label="관계">{{
                    item.relCdNm
                  }}</md-table-cell>
                  <md-table-cell md-label="삭제">
                    <button
                      class="btn-in-table"
                      @click="disconnectFamily(item)"
                    >
                      <md-icon>remove</md-icon>
                    </button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="right">
              <div class="flex-div">
                <div class="inline-flex">
                  <input
                    type="text"
                    placeholder="교우 검색"
                    v-model="selectedRelationMemberNm"
                  />
                  <button
                    @click="
                      () => {
                        this.memberModalMode = 'relation';
                        this.isShowMemberModal = true;
                      }
                    "
                  >
                    <md-icon>search</md-icon>
                  </button>
                  <select v-model="selectedRelationCd">
                    <option value="">관계선택</option>
                    <option
                      v-for="item in relationList"
                      :key="item.code"
                      :value="item.code"
                      :label="item.codeNm"
                    >
                    </option>
                  </select>
                  <md-button
                    class="md-info md-sm"
                    @click="saveRelations"
                    :disabled="
                      !selectedRelationMemberNm || !this.selectedRelationCd
                    "
                  >
                    <md-icon>check</md-icon>저장</md-button
                  >
                </div>
              </div>
            </md-card-actions>
          </div>
          <div v-show="showTab === 11">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-80 no-padding">
                  <md-table
                    :value="consultHistoryData"
                    class="paginated-table table-striped table-hover text-align-center h-scroll h300"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="상담일자">{{
                        item.insertDate
                      }}</md-table-cell>
                      <md-table-cell md-label="대분류">{{
                        item.consult1CdNm
                      }}</md-table-cell>
                      <md-table-cell md-label="소분류">{{
                        item.consult2CdNm
                      }}</md-table-cell>
                      <md-table-cell
                        md-label="상담내용"
                        style="text-align: left;"
                        >{{ item.consultDesc }}</md-table-cell
                      >
                      <md-table-cell md-label="상담자">{{
                        item.userNo
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
                <div class="md-layout-item md-size-20 no-padding">
                  <table class="flex-table mb10">
                    <tr>
                      <th>상담 입력</th>
                    </tr>
                    <tr>
                      <td>
                        <select
                          v-model="consulting.consult1Cd"
                          @change="changedConsult1CdType($event)"
                        >
                          <option selected value="">상담 대분류 선택</option>
                          <option
                            v-for="item in consult1CdTypeList"
                            :key="item.code"
                            :value="item.code"
                            :label="item.codeNm"
                          ></option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <select v-model="consulting.consult2Cd">
                          <option selected value="">상담 소분류 선택</option>
                          <option
                            v-for="item in consult2CdTypeList"
                            :key="item.code"
                            :value="item.code"
                            :label="item.codeNm"
                          ></option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea
                          class="h70"
                          v-model="consulting.consultDesc"
                        ></textarea>
                      </td>
                    </tr>
                  </table>

                  <md-button
                    class="md-info md-sm full-size-button"
                    @click="sendConsult"
                  >
                    <md-icon>check</md-icon>
                    입력
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </div>
          <div v-show="showTab === 12">
            <md-card-content>
              <md-table
                :value="medicalCardPrtData"
                class="paginated-table table-striped table-hover text-align-center h-scroll h300"
              >
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="발행일자">{{
                    item.createTime
                  }}</md-table-cell>
                  <md-table-cell md-label="구분">{{ item.v2 }}</md-table-cell>
                  <md-table-cell md-label="작업자">{{ item.v3 }}</md-table-cell>
                  <md-table-cell md-label="출력"
                    ><md-button class="md-info md-sm" @click="medicalCardPrt"
                      ><md-icon>check</md-icon></md-button
                    ></md-table-cell
                  >
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
        </md-card>
      </div>
    </div>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--학력사항 등록/수정 팝업 -->
      <modal v-if="isScholarItemModalShow" class="search-friend-modal">
        <template slot="body">
          <div class="md-layout">
            <table class="flex-table">
              <tr>
                <th star>학위명</th>
                <td>
                  <select v-model="selectedScholarItem.degreeCd" name="kyjoCd">
                    <option
                      v-for="item in degreeCdList"
                      :key="item.code"
                      :label="item.codeNm"
                      :value="item.code"
                    >
                      {{ item.codeNm }}
                    </option>
                  </select>
                </td>
                <th star>대학명</th>
                <td>
                  <div class="inline-flex">
                    <input
                      type="text"
                      disabled
                      v-model="selectedScholarItem.collegeCdNm"
                    />
                    <button
                      @click="
                        () => {
                          this.isScholarSearchMajor = true;
                          this.isScholarSearchMinor = false;
                          this.isScholarSearchSmajor = false;
                          this.isShowCollegeModal = true;
                        }
                      "
                    >
                      <md-icon>search</md-icon>
                    </button>
                  </div>
                </td>
                <th star>학과명</th>
                <td>
                  <div class="inline-flex">
                    <input
                      type="text"
                      disabled
                      v-model="selectedScholarItem.classCdNm"
                    />
                    <button
                      @click="
                        () => {
                          this.isScholarSearchMajor = false;
                          this.isScholarSearchMinor = false;
                          this.isScholarSearchSmajor = false;
                          this.isScholarSearchClass = true;
                          this.isShowClassModal = true;
                          this.profile.collegeCd = this.selectedScholarItem.collegeCd;
                        }
                      "
                    >
                      <md-icon>search</md-icon>
                    </button>
                  </div>
                </td>
                <th>학번</th>
                <td>
                  <input
                    type="text"
                    maxlength="12"
                    v-model="selectedScholarItem.hakbun"
                  />
                </td>
              </tr>
              <tr>
                <th star>입학년월</th>
                <td>
                  <input
                    type="text"
                    v-mask="'######'"
                    v-model="selectedScholarItem.enterYm"
                  />
                </td>
                <th star>졸업년월</th>
                <td>
                  <input
                    type="text"
                    v-mask="'######'"
                    v-model="selectedScholarItem.graduationYm"
                  />
                </td>
                <th>졸업회수</th>
                <td>
                  <input
                    type="text"
                    v-mask="'###'"
                    v-model="selectedScholarItem.graduationNo"
                  />
                </td>
                <th>졸업전공</th>
                <td>
                  <div class="inline-flex">
                    <input
                      type="text"
                      disabled
                      v-model="selectedScholarItem.classMajorNm"
                    />
                    <button
                      @click="
                        () => {
                          this.isScholarSearchMajor = true;
                          this.isScholarSearchMinor = false;
                          this.isScholarSearchSmajor = false;
                          this.isScholarSearchClass = false;
                          this.isShowClassModal = true;
                        }
                      "
                    >
                      <md-icon>search</md-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <th>졸업이중전공</th>
                <td>
                  <div class="inline-flex">
                    <input
                      type="text"
                      disabled
                      v-model="selectedScholarItem.classSmajorNm"
                    />
                    <button
                      @click="
                        () => {
                          this.isScholarSearchMajor = false;
                          this.isScholarSearchMinor = false;
                          this.isScholarSearchSmajor = true;
                          this.isScholarSearchClass = true;
                          this.isShowClassModal = true;
                          this.profile.collegeCd = '';
                        }
                      "
                    >
                      <md-icon>search</md-icon>
                    </button>
                  </div>
                </td>
                <th star>출력여부</th>
                <td style="border-right-color: white;">
                  <div>
                    <select v-model="selectedScholarItem.printingGb">
                      <option value="Y">Y</option>
                      <option value="N">N</option>
                    </select>
                  </div>
                </td>
                <td colspan="4"></td>
              </tr>
            </table>
          </div>
        </template>
        <template slot="footer">
          <md-button class="md-info md-sm" @click="scholarItemSave">
            <md-icon>check</md-icon>저장
          </md-button>
          <md-button
            class="md-info md-sm"
            @click="scholarItemDelete"
            v-if="!isScholarNew"
          >
            <md-icon>check</md-icon>삭제
          </md-button>
          <md-button class="md-default md-sm" @click="scholarItemModalClose"
            >닫기</md-button
          >
        </template>
      </modal>

      <!--교우검색 팝업 -->
      <member-search-pop-comp
        :is-show.sync="isShowMemberModal"
        :search-text.sync="profile.memberHnm"
        @returnResult="resetVewMember2"
      ></member-search-pop-comp>

      <!--직종선택 팝업 -->
      <work-search-pop-comp1
        :is-show.sync="isShowWorkModal1"
        @returnResult="selectedWork1"
      ></work-search-pop-comp1>
      <work-search-pop-comp2
        :is-show.sync="isShowWorkModal2"
        :l-code-cd.sync="profile.workCd1"
        @returnResult="selectedWork2"
      ></work-search-pop-comp2>

      <!--직장선택 팝업 -->
      <company-search-pop-comp
        :is-show.sync="isShowCompanyModal"
        @returnResult="selectedCompany"
      ></company-search-pop-comp>

      <!--대학선택 팝업 -->
      <college-search-pop-comp
        :is-show.sync="isShowCollegeModal"
        @returnResult="selectedCollege"
      ></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp
        :is-show.sync="isShowClassModal"
        :m-code-cd="profile.collegeCd"
        @returnResult="selectedDept"
      ></class-search-pop-comp>

      <!--국가선택 팝업 -->
      <nation-search-pop-comp
        :is-show.sync="isShowNationalModal"
        @returnResult="selectedNational"
      ></nation-search-pop-comp>

      <!--주소검색 팝업 -->
      <postcode-pop-comp
        :is-show.sync="isShowPostcodeModal"
        @returnResult="handleAddress"
      ></postcode-pop-comp>
    </div>

    <!-- 의료우대증 출력 -->

    <div
      id="print"
      style="position: fixed; top: 50%; left: 50%; transform:translate(-50%, -50%);  z-index: 999999999;
    width: 500px; height: 610px; background: #fff; padding: 20px;
-webkit-box-shadow: 0px 0px 15px 5px rgba(0,0,0,0.40);
box-shadow: 0px 0px 15px 5px rgba(0,0,0,0.40);
  border-radius: 5px;
"
      v-show="showMedicalPrintModal"
    >
      <div style="outline: 2px solid #222; padding: 20px;">
        <div
          class="alce"
          style="font-size: 35px;color: #7b0024;font-family: 'Nanum Myeongjo', serif;font-weight: 600;text-align: center; "
        >
          <h4 class="flex-table" style="margin-top: 27px; margin-bottom: 30px;">
            의료우대증명서
          </h4>
        </div>
        <table class="flex-table" style="border: 0; font-size: 14px;">
          <caption class="blind"></caption>
          <colgroup>
            <col width="160px" class="flex-table" />
            <col width="" />
          </colgroup>
          <thead>
            <tr>
              <th
                style="border: 0;background: none;text-align: left; padding: 10px 0 6px 50px;font-size:14px;"
              >
                교우번호
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ profile.memberNo }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                성명
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ profile.memberHnm }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                생년월일
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ profile.birthday }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                대학/학과
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ profile.collegeCdNm }} / {{ profile.classCdNm }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                학번/횟수
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                {{ profile.hakbun }} / {{ profile.graduationNo }}
              </td>
            </tr>
            <tr>
              <th
                style="border: 0;background: none;text-align: left;padding: 10px 0 6px 50px;font-size:14px;"
              >
                회비납부년도
              </th>
              <td style="border: 0;font-size:14px;background: none;">
                <p class="medical_year">{{ profile.lastFeeYear }}</p>
              </td>
            </tr>
          </thead>
        </table>

        <div>
          <p class="alle" style="    height: 8px; font-size: 13px">
            * 상기인은 고려대학교 교우로서 의료 우대자임을 증명합니다.
          </p>
          <p class="alle" style="font-size: 13px;    letter-spacing: -1px;">
            * 이 증명서는 회비납부 해당년도 동안 유효합니다. (평생회비납부 교우
            제외)
          </p>
        </div>
        <div style="text-align: center">
          <label id="today" value=""></label>
        </div>
        <div style="text-align: center">
          <img
            src="../../../public/img/medical_sign.jpg"
            height="193"
            width="250"
          />
        </div>

        <div
          style="    position: absolute;    left: 50%;    transform: translateX(-50%);    top: 160px;    z-index: -99;"
        >
          <img
            src="../../../public/img/watermark.png"
            height="325"
            width="325"
          />
        </div>
      </div>

      <div
        id="printbutton"
        class="flex-table"
        style="text-align: center;margin-top: 20px"
      >
        <md-button
          class="md-info"
          @click="printMedicalCard(profile.memberNo)"
          :aria-disabled="showMedicalPrintModal"
          style="margin-right: 10px;width: 140px;font-size:15px;"
          >출력</md-button
        >
        <md-button
          class="md"
          @click="showMedicalPrintModal = false"
          style="width: 140px;font-size:15px;"
          >창 닫기</md-button
        >
      </div>
    </div>

    <!-- 문자발송-->
    <div
      style="position: fixed; top: 0; left: 0; z-index: 999999999; width: 100%; height: 100%; background: rgba(0,0,0,0.7)"
      v-show="showSmsModal"
    >
      <div
        style="position: absolute; top: 50%; left: 50%; width: 250px; margin: -200px 0 0 -75px; background: #fff; box-sizing: border-box; padding: 50px 15px 15px 15px;"
      >
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="showSmsModal = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
        <table class="flex-table">
          <tr>
            <td colspan="2">
              <input
                type="text"
                v-model="smsData.Phone"
                v-mask="'###-####-####'"
                placeholder="수신번호"
              />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <input
                type="text"
                v-model="smsData.Subject"
                placeholder="제목을 입력 하세요."
              />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <textarea v-model="smsData.Main_Text"></textarea>
            </td>
          </tr>
          <tr>
            <td>
              <select v-model="smsData.Service">
                <option value="SMS">SMS</option>
                <option value="LMS">LMS</option>
                <option value="MMS">MMS</option>
              </select>
            </td>
            <td>
              <md-button class="md-info md-sm" @click="sendSms">
                <md-icon>check</md-icon>
                발송
              </md-button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";

// added by psk 20200828
import { extend } from "vee-validate";
import { required, min, regex } from "vee-validate/dist/rules";
import { ko } from "vuejs-datepicker/dist/locale";

// added by psk 20200901
import vuejsDatepicker from "vuejs-datepicker";

import moment from "moment";
import _ from "lodash";

import kuaaFnc from "@/kuaa/kuaa-comm-func";

import CounselorCampaign from "@/pages/Counselor/CounselorCampaign";

import {
  MemberSearchPopComp,
  MemberSearchPopComp2,
  WorkSearchPopComp1,
  WorkSearchPopComp2,
  CompanySearchPopComp,
  CollegeSearchPopComp,
  ClassSearchPopComp,
  NationSearchPopComp,
  PostcodePopComp
} from "@/pages";
import axios from "axios";

import { Modal } from "@/components";

extend("required", required);
extend("min", min);
extend("regex", regex);

export default {
  components: {
    MemberSearchPopComp,
    /*MemberSearchPopComp2,*/
    /*WorkSearchPopComp,*/
    WorkSearchPopComp1,
    WorkSearchPopComp2,
    CompanySearchPopComp,
    CollegeSearchPopComp,
    ClassSearchPopComp,
    NationSearchPopComp,
    PostcodePopComp,
    /* vuejsDatepicker,*/
    CounselorCampaign,
    Modal
  },
  props: {
    memberNo: {
      type: String,
      default: null
    }
  },
  computed: {
    currentMemberNo() {
      return this.profile.memberNo;
    },
    donationSum() {
      let sum = 0;

      if (this.donationList) {
        this.donationList.forEach(item => {
          sum += +item.giveAmount;
        });
      }
      return formatter.getCurrency(sum);
    },
    donationCount() {
      if (this.donationList) return this.donationList.length;
      else return 0;
    },
    applyDonationSum() {
      let sum = 0;

      if (this.applyDonationList) {
        this.applyDonationList.forEach(item => {
          sum += item.kuaaAmount + item.schaAmount + item.reserveAmount;
        });
      }

      return formatter.getCurrency(sum);
    },
    applyDonationCount() {
      if (this.applyDonationList) return this.applyDonationList.length;
      else return 0;
    }
  },
  watch: {
    profile() {
      this.changeNonPostReceiptType();
    }
  },
  data() {
    return {
      formatter,
      isScholarNew: false,
      userGroup: null,

      showTab: 2,
      isShowAddressCard: false,

      smsData: {
        UserID: "",
        UserPW: "",
        Service: "SMS",
        Type: "Send",
        Callback: "",
        Subject: "",
        Main_Text: "",
        Phone: ""
      },

      showSmsModal: false,

      showMedicalPrintModal: false,

      viewMode: 1, // 하단 영역 모드 1 : 주소정보 이력사항, 2 : 캠페인 상담사

      showAddresType: 1, // 국내 해외 주소정보

      // 교원 구분
      staffTypeList: [],

      // 회원 등급
      memberLevelTypeList: [],
      scholarHistoryData: [],
      workHistoryData: [],
      memberWorkHisGb: [],
      addressHistoryData: [],
      feeHistoryData: [],
      orgHistoryData: [],
      prizeHistoryData: [],
      eventJoinerData: [],
      donationList: [],
      applyDonationList: [],
      benefitDonationList: [],

      bornCdList: [],

      familyData: [],
      relationList: [], //관계 리스트
      selectedRelationMemberNo: "", // 관계 맺을 교우번호
      selectedRelationMemberNm: "", // 관계 맺을 교우명
      selectedRelationCd: "", // 선택한 관계 코드

      consultHistoryData: [],

      consult1CdTypeList: [], // 상담코드 대분류
      consult2CdTypeList: [], // 상담코드 소분류(대분류가 바뀌면 새로 로드함)
      consulting: {
        //목록에서 컨설팅 입력
        consult1Cd: "",
        consult2Cd: "",
        consultDesc: "",
        seqNo: ""
      },

      medicalCardPrtData: [],
      postReceiptTypeList: [],
      nonPostReceiptTypeList: [],

      savedImgUrl: "",
      savedFileBaseId: "", //삭제시 넘겨줄 key
      photoFileName: "",
      photoFileSize: null,
      photoFile: null,

      isShowPostcodeModal: false,
      selectedAddressType: "1",
      profile: {
        memberNo: "", // 교우번호
        memberHnm: "", // 교우명(한글)
        memberCnm: "", // 교우명(한자)
        memberEnm: "", // 교우명(영문)
        prevNm: "", // 개명 전
        enterYm: "", // 입학년월
        graduationYm: "", // 졸업년월
        hakbun: "", // 학번
        graduationNo: "0", // 졸업횟수
        collegeCd: "", // 대학코드
        classCd: "", // 학과코드
        sex: "", // 성별
        birthday: "", // 생일
        birthGb: "", // 1 : 음력, 2 : 양력
        weddingGb: "", // Y : 기혼, N : 미혼
        weddingday: "", // 결혼기념일
        nationalCd: "", // 국적
        registerNo: "", // 등록번호(주민번호)
        cellular: "", // 휴대전화
        cellularDeny: "", // 휴대전화 수신거부
        secretary: "", // 상임이사중 연회비 납부여부
        secretaryTel: "", // 비서연락처
        eMail: "", // 이메일
        eMailDeny: "", // 이메일 수신거부
        eMail2: "", // 이메일2
        eMail2Deny: "", // 이메일2 수신거부
        homepage: "", // 홈페이지
        webid: "", // 웹아이디
        webpass: "", // 웹패스워드
        postplace: "", // 우편물발송지
        nonpostGb: "", // 미발송구분
        status: "", // 1 : 정상, 2 : 작고
        memberGb: "", // Y : 평생회원, N : 평생회원 아님
        memberorgGb: "", // ?? : 임원진직위코드, 00 : 직위없음
        memberorgGbNm: "", // ?? : 임원진직위코드, 00 : 직위없음
        memberjbGb: "", // JN : 지부, NB : 분회, JB : 지부/분회, NN : ??
        lastFeeDate: "", // 최종회비납입일
        lastFeeYear: "", // 최종회비납입년도
        highschool: "", // 출신고교
        remark: "", // 설명
        staffCd: "", // 스텝코드
        confirmGb: "", // Y : 검증됨, N : 검증안됨
        joinDate: "", // 입사일
        companyId: "", // 직장코드
        companyNm: "", // 직장명
        levelNm: "", // 직위
        partNm: "", // 부서
        positionNm: "", // 직책
        homeGb: "", // 0 : 구주소, 1 : 도로명주소
        homeZipcd: "", // 자택우편번호
        homeAddress1: "", // 주소1
        homeAddress2: "", // 주소2
        homeAddress3: "", // 도로명 주소1
        homeAddress4: "", // 도로명 주소2
        homeAddressDeny: "", // 자택주소 수신거부
        homeTel: "", // 전화번호
        homeFax: "", // 팩스번호
        homeStatus: "", // Y : YES, N : NO
        officeGb: "", // 0 : 구주소, 1 : 도로명주소
        officeZipcd: "", // 직장우편번호
        officeAddress1: "", // 직장주소1
        officeAddress2: "", // 직장주소2
        officeAddress3: "", // 직장 도로명 주소1
        officeAddress4: "", // 직장 도로명 주소2
        officeAddressDeny: "", // 직장 주소 수신거부
        officeTel: "", // 대표전화번호
        officeDirect: "", // 직통전화번호
        officeInner: "", // 내선번호
        officeFax: "", // 사무실 팩스
        officeStatus: "", // Y : YES, N : NO
        anationalCd: "", // 국외 국가코드
        ahomeGb: "", // 0 : 구주소, 1 : 도로명주소
        ahomeAddress1: "", // 국외주소1
        ahomeAddress2: "", // 국외주소2
        ahomeAddress3: "", // 국외주소3
        ahomeAddressDeny: "", // 국외주소 수신거부
        ahomeTel: "", // 국외전화번호
        ahomeFax: "", // 국외팩스번호
        ahomeStatus: "",
        aofficeAddress1: "", // 국외직장주소1
        aofficeAddress2: "", // 국외직장주소2
        aofficeAddress3: "", // 국외직장주소3
        aofficeAddressDeny: "", // 국외직장주소 수신거부
        aofficeTel: "", // 국외직장전화번호
        aofficeFax: "", // 국외직장팩스번호
        aofficeStatus: "", // Y : YES, N : NO
        insertDate: "", // 입력일시
        updateDate: "", // 변경일시
        addrUpdateDate: "", //주소변경일시
        hUpdateDate: "", // 국내주소변경일시
        oUpdateDate: "", // 국내사무실변경일시
        ahUpdateDate: "", // 해외거주지변경일시
        aoUpdateDate: "", // 해외사무실변경일시
        userNo: "",
        mlevelCd: "",
        seqNo: "", // tb_scholar key
        workCd1: "",
        workCd2: "",
        workCd1Nm: "",
        workCd2Nm: "",
        workhisGb: "",
        bornCd: "",
        webJoinDate: ""
      },

      branchMemberList: [],
      branchZMemberList: [],

      // 국적 조회
      nationalModalSearchText: "", // modal 에서 사용하는 검색어
      searchedNationalName: "", //modal 에서 검색 후 화면에 세팅하는 결과 (개인정보)
      searchedAhomeAddressNationalName: "", //modal 에서 검색 후 화면에 세팅하는 결과 (해외 거주지)
      searchedAofficeAddressNationalName: "", //modal 에서 검색 후 화면에 세팅하는 결과 (해외 직장)
      searchedRelationNationalName: "", //modal 에서 검색 후 화면에 세팅하는 결과 (가족교우)
      isShowNationalModal: false, //modal 보임/감춤
      nationalModalMode: "profile", //국적조회 팝업 모드

      // 대학 선택 데이터
      collegeModalSearchText: "",
      searchedCollegeName: "",
      isShowCollegeModal: false,

      // 학과 선택 데이터
      deptModalSearchText: "",
      searchedClassName: "",
      isShowClassModal: false,

      // 직종 검색
      //      workCd1Nm: "",
      isShowWorkModal1: false,

      //      workCd2Nm: "",
      isShowWorkModal2: false,

      // 직장명 검색
      //      companyNm: "",
      isShowCompanyModal: false,

      // 교우 검색
      isShowMemberModal: false,
      memberModalMode: "profile", // 교우검색 팝업 모드

      imageUrl: null, // added by psk 20200828
      isClick: false,
      datepickerLang: ko,

      isScholarItemModalShow: false,
      isScholarItemSaveMode: false,
      isScholarSearchMajor: false,
      isScholarSearchMinor: false,
      isScholarSearchSmajor: false,
      isScholarSearchClass: false,
      selectedScholarItem: {
        // 학력사항 항목
        memberNo: ""
      },
      degreeCdList: [],
      printingGb: null
    };
  },

  created() {
    Promise.all([
      // 교원종류 공통코드 조회
      this.queryStaffTypes(),
      // 회원등급 공통코드 조회
      this.queryMemberLevelTypes(),
      this.queryMemberWorkHisGb(),
      // 우편물 수령처 목록
      this.queryPostReceiptTypes(),
      // 우편물미수령 사유 목록
      this.queryNonPostReceiptTypes(),
      //학위명
      this.getDegreeCdList(),
      //본적
      this.getBornCdList()
    ]).then(function() {});

    this.userGroup = session.get("group");

    if (this.memberNo) {
      this.resetVewMember(this.memberNo);
    }

    if (this.$route.query.TelNo) {
      let _this = this;
      setTimeout(function() {
        _this.setCalling(_this.$route.query.TelNo);
      }, 1000);
    }
  },

  methods: {
    payCard() {
      window.open("http://www.bill36524.com/service/mbaropay/login.jsp");
    },

    resetVewMember(memberNo) {
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        { memberNo: memberNo, printingGb: "Y" },
        "post",
        response => {
          this.profile = response.data.data.contents[0];
          this.memberModalMode = "profile";
          this.onSelectedModalMember(response.data.data.contents[0]);
        }
      );
    },

    resetVewMember2(item) {
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        { memberNo: item.memberNo, printingGb: "Y" },
        "post",
        response => {
          this.onSelectedModalMember(response.data.data.contents[0]);
        }
      );
    },
    setCalling(telno) {
      this.$refs.counselorCampaign.inboundCall(telno);
    },

    callingCallback(item) {
      this.profile = item;
      this.memberModalMode = "profile";
      this.onSelectedModalMember(item);
    },

    /**
     * 교원구분 - 공통코드 조회 세팅
     */
    queryStaffTypes() {
      kuaaFnc.fncStaffTypes(null, res => {
        this.staffTypeList = res.data.data.contents;
      });
    },

    /**
     * 회원 등급 - 공통코드 조회 세팅
     */
    queryMemberLevelTypes() {
      kuaaFnc.fncMemberLevelTypes(null, res => {
        this.memberLevelTypeList = res.data.data.contents;
      });
    },

    queryMemberWorkHisGb() {
      kuaaFnc.fncWorkHisGbList(null, res => {
        this.memberWorkHisGb = res.data.data.contents;
      });
    },

    /**
     * 우편물 수령처 목록
     */
    queryPostReceiptTypes() {
      kuaaFnc.fncPostReceiptTypes(null, res => {
        this.postReceiptTypeList = res.data.data.contents;
      });
    },

    changeNonpostGb() {
      this.profile.nonpostGb = "00";
    },
    changeNonPostReceiptType() {
      if (this.profile && this.profile.nonpostGb == "09") {
        this.showAddresType = 2;
      }
    },
    /**
     * 우편물미수령 사유 목록
     */
    queryNonPostReceiptTypes() {
      kuaaFnc.fncNonPostReceiptTypes(null, res => {
        this.nonPostReceiptTypeList = res.data.data.contents;
      });
    },

    /**
     * 우편물미수령 사유 목록
     */
    getDegreeCdList() {
      kuaaFnc.fncDegreeCdList(null, res => {
        this.degreeCdList = res.data.data.contents;
      });
    },

    /**
     * 우편물미수령 사유 목록
     */
    getBornCdList() {
      kuaaFnc.fncBornCodes(null, res => {
        this.bornCdList = res.data.data.contents;
      });
    },
    /************************************************************************************
     *여기부터 탭 클릭 조회
     ************************************************************************************/
    onClickTab(index) {
      if (!this.profile.memberNo) {
        kuaaFnc.showSwal("이력사항 조회", "교우를 먼저 선택후 진행해 주세요");
        return false;
      }
      this.showTab = index;
      switch (index) {
        case 1:
          this.queryScholarHistory();
          break;
        case 2:
          this.queryWorkHistory();
          break;
        case 3:
          this.queryAddressHistory();
          break;
        case 4:
          this.queryFeeHistory();
          break;
        case 5:
          this.queryOrgHistory();
          break;
        case 6:
          this.queryPrizeHistory();
          break;
        case 7:
          this.queryEventJoiner();
          break;
        case 8:
          this.queryDonationHistory();
          break;
        case 9:
          this.queryScholarshipHistory();
          break;
        case 10:
          this.queryFamily();
          break;
        case 11:
          this.queryConsultHistory();
          break;
        case 12:
          this.queryMedicalCardPrt();
          break;
      }
    },

    /**
     * 학력사항 탭 조회
     */
    queryScholarHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_SCHOLAR_LIST,
        options,
        "post",
        response => {
          this.scholarHistoryData = response.data.data.contents;
        }
      );
    },

    /**
     * 학력사항 항목 선택
     */
    selectScholarItem(item) {
      this.isScholarNew = false;
      this.printingGb = item.printingGb;
      //if(this.userGroup == '3' || this.userGroup == '5'){
      if (
        this.userGroup == "3" ||
        this.userGroup == "5" ||
        this.userGroup == "2"
      ) {
        this.selectedScholarItem = item;
        this.isScholarItemModalShow = true;
        this.isScholarItemSaveMode = false;
      }
    },

    scholarItemModalClose() {
      this.isScholarItemModalShow = false;
    },

    /**
     * 학력사항 신규 클릭
     */
    addScholarItem() {
      if (!this.isScholarNew) {
        this.selectedScholarItem = {
          memberNo: this.currentMemberNo,
          printingGb: "N"
        };
        this.isScholarNew = true;
        this.printingGb = null;
      }
      this.isScholarItemModalShow = true;
      this.isScholarItemSaveMode = true;
    },

    /**
     * 학력사항 등록/수정
     */
    scholarItemSave() {
      let _this = this;
      this.isScholarItemModalShow = false;
      let modalOptions = "";

      if (!this.selectedScholarItem.degreeCd) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "학위를 선택해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      if (!this.selectedScholarItem.collegeCd) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "대학을 선택해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      if (!this.selectedScholarItem.classCd) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "학과를 선택해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      // if(!this.selectedScholarItem.hakbun){
      //   kuaaFnc.showSwal("학력 저장", '학번을 입력해 주세요');
      //   return false;
      // };

      if (!this.selectedScholarItem.enterYm) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "입학년월을 입력해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      if (!this.selectedScholarItem.graduationYm) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "졸업년월을 입력해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      // if(this.selectedScholarItem.printingGb == "Y"){
      //   modalOptions = kuaaFnc.getSwalModaloptions({
      //     html: "출력여부를 확인해주세요<br>[출력여부 'Y'인 경우 변경 불가]",
      //   });
      //   Swal.fire(modalOptions).then(() => _this.isScholarItemModalShow = true);
      //   return false;
      // }

      modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
        html: "저장하시겠습니까?"
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            this.isScholarItemSaveMode
              ? URL_CONST.SAVE_SCHOLAR
              : URL_CONST.UPDATE_SCHOLAR,
            this.selectedScholarItem,
            "post",
            response => {
              this.isScholarNew = false;
              this.queryScholarHistory();
              this.campaignMemberChange(this.profile.memberNo);
            }
          );
        }
      });
    },

    /**
     * 학력사항 삭제
     */
    scholarItemDelete() {
      this.isScholarItemModalShow = false;

      let modalOptions = "";
      if (!this.selectedScholarItem.seqNo) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "삭제할 학력사항을 선택해 주세요"
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }

      if (this.printingGb == "Y") {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: '출력여부를 확인해주세요<br>[출력여부 "Y"는 삭제 불가]'
        });
        Swal.fire(modalOptions).then(
          () => (_this.isScholarItemModalShow = true)
        );
        return false;
      }
      modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
        html: "삭제하시겠습니까?"
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHOLAR,
            this.selectedScholarItem,
            "post",
            response => {
              this.queryScholarHistory();
              this.campaignMemberChange(this.profile.memberNo);
            }
          );
        }
      });
    },

    /**
     * 직장이력 탭 조회
     */
    queryWorkHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_WORK_HIS_LIST,
        options,
        "post",
        response => {
          this.workHistoryData = response.data.data.contents;
          // this.workHistoryData = _.orderBy(response.data.data.contents, (obj)=>{
          //   return obj.happenDate;
          // },'desc');
        }
      );
    },

    /**
     * 주소이력 탭 조회
     */
    queryAddressHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_ADDR_HIS_LIST,
        options,
        "post",
        response => {
          this.addressHistoryData = response.data.data.contents;
          // this.addressHistoryData = _.orderBy(response.data.data.contents, (obj)=>{
          //   return obj.updateDate;
          // },'desc');
        }
      );
    },

    /**
     * 회비내역 탭 조회
     */
    queryFeeHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(URL_CONST.GET_FEE_LIST, options, "post", response => {
        this.feeHistoryData = response.data.data.contents;
        // this.feeHistoryData = _.orderBy(response.data.data.contents, (obj)=>{
        //   return obj.feeDate;
        // },'desc');
      });
    },

    /**
     * 임원이력 탭 조회
     */
    queryOrgHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_ORG_HIS_LIST,
        options,
        "post",
        response => {
          this.orgHistoryData = response.data.data.contents;
          // this.orgHistoryData = _.orderBy(response.data.data.contents, (obj)=>{
          //   return obj.erectDate;
          // },'desc');
        }
      );
    },

    /**
     * 경조사이력 탭 조회
     */
    queryPrizeHistory() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
        // memberNo: 'K0104961'
      };
      kuaaApi.sendServer(
        URL_CONST.GET_PRIZE_LIST,
        options,
        "post",
        response => {
          this.prizeHistoryData = response.data.data.contents;
          // this.prizeHistoryData = _.orderBy(response.data.data.contents, (obj)=>{
          //   return obj.useDate;
          // },'desc');
        }
      );
    },

    /**
     * 행사참여 탭 조회
     */
    queryEventJoiner() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_EVENT_JOINER_LIST,
        options,
        "post",
        response => {
          this.eventJoinerData = response.data.data.contents;
        }
      );
    },

    /**
     * 기부금(장학) 탭 조회
     */
    queryDonationHistory() {
      kuaaApi.sendServer(
        URL_CONST.GET_DONATION_LIST,
        { memberNo: this.currentMemberNo },
        "post",
        res => {
          this.donationList = res.data.data.contents.donationList;
          this.applyDonationList = res.data.data.contents.applyDonationList;
        }
      );
    },

    /**
     * 장학금 수혜 탭 조회
     */
    queryScholarshipHistory() {
      kuaaApi.sendServer(
        URL_CONST.GET_BENEFIT_DONATION_LIST,
        { memberNo: this.currentMemberNo },
        "post",
        response => {
          this.benefitDonationList = response.data.data.contents;
        }
      );
    },

    /**
     * 가족교우 탭 조회
     */
    queryFamily() {
      if (this.relationList) {
        kuaaFnc.fncRelCodes(null, res => {
          this.relationList = res.data.data.contents;
        });
      }

      let options2 = {
        mMemberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_RELATIONS_LIST,
        options2,
        "post",
        response => {
          this.familyData = response.data.data.contents;
        }
      );
    },

    /**
     * 가족교우 저장
     */
    saveRelations() {
      let options = {
        mMemberNo: this.currentMemberNo,
        sMemberNo: this.selectedRelationMemberNo,
        relCd: this.selectedRelationCd
      };

      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "요청을 처리하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.SAVE_RELATIONS,
            options,
            "post",
            response => {
              if (response.data.success) {
                kuaaFnc.showSwal("가족교우 저장", "가족교우가 저장 되었습니다");
                this.selectedRelationMemberNo = "";
                this.selectedRelationMemberNm = "";
                this.selectedRelationCd = "";
                this.queryFamily();
              } else {
                kuaaFnc.showSwal("가족교우 저장", response.data.resultMessage);
              }
            }
          );
        }
      });
    },

    /**
     * 상담내역 탭 조회
     */
    queryConsultHistory() {
      kuaaFnc.fncConsultLCodes(null, res => {
        this.consult1CdTypeList = res.data.data.contents;
      });

      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_CONSULT_HIS_LIST,
        options,
        "post",
        response => {
          this.consultHistoryData = response.data.data.contents;
        }
      );
    },

    /**
     * 상담내역 탭에서 대분류를 변경함 -> 소분류를 새로 로드함
     */
    changedConsult1CdType(e) {
      kuaaFnc.fncConsultMCodes(e.target.value, null, res => {
        this.consult2CdTypeList = res.data.data.contents;
      });
    },

    /**
     * 상담 서버 전송
     */
    sendConsult() {
      this.consulting.memberNo = this.currentMemberNo;
      this.consulting.callId = "00000000"; //callId 고정

      kuaaApi.sendServer(
        URL_CONST.SAVE_CONSULT,
        this.consulting,
        "post",
        response => {
          this.queryConsultHistory();
          this.consulting.consult1Cd = "";
          this.consulting.consult2Cd = "";
          this.consulting.consultDesc = "";
        }
      );
    },

    /**
     * 의료 우대증 탭 조회
     */
    queryMedicalCardPrt() {
      let options = {
        memberNo: this.currentMemberNo,
        perPage: 1000
      };
      kuaaApi.sendServer(
        URL_CONST.GET_MEDICAL_CARD_PRT_LIST,
        options,
        "post",
        response => {
          this.medicalCardPrtData = response.data.data.contents;
        }
      );
    },
    medicalCardPrt() {
      let today = new Date();

      let year = today.getFullYear(); // 년도
      let month = today.getMonth() + 1; // 월
      let date = today.getDate(); // 날짜
      let day = today.getDay(); // 요일

      document.getElementById("today").innerText =
        year + "." + month + "." + date;
      this.showMedicalPrintModal = true;
    },

    printMedicalCard(memberNo) {
      document.getElementById("printbutton").style.display = "none";

      window.onbeforeprint = function() {
        document.body.outerHTML = document.getElementById("print").outerHTML;
      };
      window.onafterprint = function() {
        location.href = window.location.href + "/" + memberNo;
        document.getElementById("printbutton").style.display = "";
      };
      window.print();
    },

    onSelectedModalMember(item) {
      switch (this.memberModalMode) {
        case "profile":
          this.resetData();
          this.isShowAddressCard = false;
          //TODO : read only 설정 필요
          this.onClickModalMember(item);
          this.searchedCollegeName = item.collegeCdNm;
          this.searchedClassName = item.classCdNm;
          this.searchedNationalName = item.nationalCdNm;

          this.searchedAhomeAddressNationalName = item.anationalCdNm;
          this.searchedAofficeAddressNationalName = item.anationalCdNm;

          if (item.nonpostGb == "09") {
            this.showAddresType = 2;
          } else {
            this.showAddresType = 1;
          }
          if (
            item.homeZipcd ||
            item.officeZipcd ||
            item.ahomeAddress1 ||
            item.aofficeAddress1
          )
            this.isShowAddressCard = true;

          if (item.fileBaseId) {
            this.savedImgUrl =
              URL_CONST.FILE_DOWN_LOAD + "?fileBaseId=" + item.fileBaseId;
            this.savedFileBaseId = item.fileBaseId;
            this.photoFileName = item.orgFileNm;
            this.photoFileSize = item.fileSize;
          } else {
            this.savedImgUrl = null;
            this.savedFileBaseId = null;
            this.photoFileName = null;
            this.photoFileSize = null;
          }
          this.queryFamily(); // 가족교우 조회
          this.getBranchMemberList(1); // 단체 조회
          this.getBranchMemberList(2); // 단체 조회
          this.onClickTab(1);
          break;
        case "relation":
          this.onClickModalRelationMember(item);
          break;
      }
    },

    /**
     * 모달 교우선택 목록에서 교우를 선택 (교우 변경 기능)
     */
    onClickModalMember(item) {
      this.isCreateMode = false;
      this.isShowMemberModal = false;
      this.profile = item;
      this.$emit("update:memberNo", item.memberNo);
    },

    /**
     * 가족교우 탭에서 모달 교우선택 목록에서 교우를 선택
     * 해당 영역에 세팅 해주고 모달은 닫음.
     */
    onClickModalRelationMember(item) {
      this.isCreateMode = false;
      this.selectedRelationMemberNm = item.memberHnm;
      this.selectedRelationMemberNo = item.memberNo;
    },
    hideSearchNationalModal: function() {
      this.isShowSearchNationalModal = false;
    },
    hideSearchDeptModal: function() {
      this.isShowSearchDeptModal = false;
    },
    removeJobHistory(item) {
      // TODO: 직장 이력 구현
    },
    disconnectFamily(item) {
      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "요청을 처리하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_RELATIONS,
            item,
            "post",
            response => {
              if (response.data.success) {
                kuaaFnc.showSwal("가족교우 삭제", "가족교우를 삭제하였습니다");
                this.queryFamily();
              } else {
                kuaaFnc.showSwal("가족교우 삭제", response.data.resultMessage);
              }
            }
          );
        }
      });
    },
    handleAddress: function(data) {
      if (!data) return false;

      let zonecode = data.zonecode; // 우편번호
      let roadAddress = data.roadAddress; // 도로명주소
      let jibunAddress = data.jibunAddress; // 지번 주소
      let fullAddress = data.address; // 기본주소
      let extraAddress = "";

      if (data.addressType === "R") {
        if (data.buildingName !== "") {
          extraAddress += " (" + data.buildingName + ")";
        }

        fullAddress += extraAddress !== "" ? `${extraAddress}` : "";
      }

      if (this.selectedAddressType === "1") {
        if (this.profile.homeStatus == "N") this.profile.homeStatus = "Y";
        this.profile.homeGb = data.addressType === "R" ? "1" : "0";
        this.profile.homeZipcd = zonecode;
        this.profile.homeAddress1 = roadAddress;
        this.profile.homeAddress2 = extraAddress;

        let homeAddress2Input = this.$refs.homeAddress2Input;
        setTimeout(function() {
          homeAddress2Input.focus();
          homeAddress2Input.setSelectionRange(0, 0);
        }, 100);
      } else if (this.selectedAddressType === "2") {
        if (this.profile.officeStatus == "N") this.profile.officeStatus = "Y";
        this.profile.officeGb = data.addressType === "R" ? "1" : "0";
        this.profile.officeZipcd = zonecode;
        this.profile.officeAddress1 = roadAddress;
        this.profile.officeAddress2 = extraAddress;

        let officeAddress2Input = this.$refs.officeAddress2Input;
        setTimeout(function() {
          officeAddress2Input.focus();
          officeAddress2Input.setSelectionRange(0, 0);
        }, 100);
      }

      this.isShowPostcodeModal = false;
    },
    addressModalOpen: function(addressType, event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.isShowPostcodeModal = true;
      this.selectedAddressType = addressType;
    },
    onClickSearchProfilePhoto: function(event) {
      let input = document.getElementById("photoFileInput");

      input.onchange = e => {
        let file = e.target.files[0];
        this.photoFileName = file.name;
        this.fileSize = file.size;
        this.photoFile = file;

        // added by psk 20200828
        this.imageUrl = URL.createObjectURL(file);

        console.log("이미지 URL 확인 : " + this.imageUrl);
      };

      input.click();
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    selectedNational(item) {
      let nationalMode;
      switch (this.nationalModalMode) {
        case "profile":
          this.searchedNationalName = item.codeNm; //화면 표시용
          this.profile.nationalCd = item.code; //DB 저장용
          this.profile.ahomeAddress1 = item.codeNm;
          break;
        case "ahomeAddress":
          this.searchedAhomeAddressNationalName = item.codeNm; //화면 표시용
          this.profile.anationalCd = item.code; //DB 저장용
          this.profile.ahomeAddress1 = item.codeNm;
          break;
        case "aofficeAddress":
          this.searchedAofficeAddressNationalName = item.codeNm; //화면 표시용
          this.profile.anationalCd = item.code; //DB 저장용
          this.profile.aofficeAddress1 = item.codeNm;
          break;
        case "relationMember":
          nationalMode = this.searchedRelationNationalName;
          this.searchedRelationNationalName = item.codeNm; //화면 표시용
          this.profile.relationMember = item.codeNm;
          break;
      }
      this.isShowNationalModal = false;
    },

    selectedCollege: function(item) {
      this.isShowCollegeModal = false;

      // 학력사항 등록/수정인 경우
      if (this.isScholarItemModalShow) {
        this.selectedScholarItem.collegeCd = item.code;
        this.selectedScholarItem.collegeCdNm = item.codeNm;
        this.searchedCollegeName = item.codeNm;
        this.profile.collegeCd = item.code;
        this.selectedScholarItem.classMajor = "";
        this.selectedScholarItem.classMinor = "";
        this.selectedScholarItem.classSmajor = "";
      } else {
        this.searchedCollegeName = item.codeNm;
        this.profile.collegeCd = item.code;
        this.searchedClassName = ""; // 대학을 새로 선택했으므로 학과는 리셋 (collegeCd 는 윗줄에서 이미 리셋 됨)
        this.isShowClassModal = true;
      }
    },

    /**
     * 학과 검색
     */
    selectedDept: function(item) {
      this.isShowClassModal = false;

      // 학력사항 등록/수정인 경우
      if (this.isScholarItemModalShow) {
        if (this.isScholarSearchMajor) {
          this.selectedScholarItem.classMajor = item.code;
          this.selectedScholarItem.classMajorNm = item.codeNm;
        } else if (this.isScholarSearchMinor) {
          this.selectedScholarItem.classMinor = item.code;
          this.selectedScholarItem.classMinorNm = item.codeNm;
        } else if (this.isScholarSearchSmajor) {
          this.selectedScholarItem.classSmajor = item.code;
          this.selectedScholarItem.classSmajorNm = item.codeNm;
        } else if (this.isScholarSearchClass) {
          this.selectedScholarItem.classCd = item.code;
          this.selectedScholarItem.classCdNm = item.codeNm;
          this.selectedScholarItem.collegeCd = item.mCodeCd;
          this.selectedScholarItem.collegeCdNm = item.mCodeNm;
        }
      } else {
        this.searchedClassName = item.codeNm;
        this.profile.classCd = item.code;
      }
    },

    /**
     * 직종 검색
     */
    selectedWork1: function(item) {
      this.isShowWorkModal1 = false;
      let isAlert = false;
      let msg = "";

      if (
        this.profile.workCd1 != item.code &&
        (this.profile.companyId || this.profile.workCd2)
      ) {
        if (this.profile.workCd2) {
          this.profile.workCd2Nm = "";
          this.profile.workCd2 = "";
          this.msg = "직종소분류";
        }
        if (this.profile.companyId) {
          this.profile.companyNm = "";
          this.profile.companyId = "";
          if (this.msg) this.msg += "/직장";
          else this.msg = "직장";
        }
        isAlert = true;
      }
      this.profile.workCd1Nm = item.codeNm;
      this.profile.workCd1 = item.code;
      if (isAlert)
        kuaaFnc.showSwal(
          "직종 대분류 선택",
          `[${this.msg}] 을 다시 입력해 주세요`
        );
    },

    selectedWork2: function(item) {
      this.isShowWorkModal2 = false;
      let isAlert = false;
      if (
        this.profile.companyId &&
        (this.profile.workCd1 != item.lCodeCd ||
          this.profile.workCd2 != item.code)
      ) {
        this.profile.companyNm = "";
        this.profile.companyId = "";
        isAlert = true;
      }
      this.profile.workCd1Nm = item.lCodeNm;
      this.profile.workCd1 = item.lCodeCd;
      this.profile.workCd2Nm = item.codeNm;
      this.profile.workCd2 = item.code;
      if (isAlert)
        kuaaFnc.showSwal(
          "직종 소분류 선택",
          "직종에 맞는 직장을 다시 입력해 주세요"
        );
    },

    /**
     * 직장명 검색
     */
    selectedCompany: function(item) {
      this.isShowCompanyModal = false;
      if (item) {
        this.companyNm = item.codeNm;
        this.profile.companyId = item.code;
        this.profile.companyNm = item.codeNm;
        if (item.code) {
          this.profile.workCd1 = item.lCodeCd;
          this.profile.workCd1Nm = item.lCodeNm;
          this.profile.workCd2 = item.mCodeCd;
          this.profile.workCd2Nm = item.mCodeNm;
        } else {
          this.profile.workCd1 = "";
          this.profile.workCd1Nm = "";
          this.profile.workCd2 = "";
          this.profile.workCd2Nm = "";
        }
      }
    },

    /**
     * 개인기본정보 저장
     */
    async saveBasicInfo(e) {
      if (this.profile.memberNo == null || this.profile.menberNo == "") {
        kuaaFnc.showSwal("교우 관리", "교우를 먼저 선택해 주세요.");
        return false;
      }

      const formCheck = await this.$refs.saveBasicInfoForm.validate();
      if (!formCheck) {
        if (this.profile.memberHnm === "") {
          kuaaFnc.showSwal("교우 정보 저장", "교우명을 입력해 주십시오.");

          //} else if (this.profile.sex === "") {
          //  kuaaFnc.showSwal("교우 정보 저장", '성별을 선택해 주십시오.');
        } else if (this.profile.memberNo === "") {
          kuaaFnc.showSwal("교우 정보 저장", "교우번호를 입력해 주십시오.");
        }

        return;
      }

      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "요청을 처리하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.SAVE_MEMBER,
            this.profile,
            "post",
            response => {
              if (response.data.success) {
                this.savePhoto();
                this.resetVewMember(this.profile.memberNo);
                setTimeout(function() {
                  kuaaFnc.showSwal(
                    "교우 정보 저장",
                    "교우 정보가 저장 되었습니다."
                  );
                }, 150);
              } else {
                kuaaFnc.showSwal("교우 정보 저장", response.data.resultMessage);
              }
            }
          );
        }
      });
    },
    async saveDetailInfo() {
      if (!this.profile.memberNo) {
        kuaaFnc.showSwal(
          "주소 정보 저장",
          "교우를 먼저 선택후 다시 진행해 주세요."
        );
        return false;
      }

      const formCheck = await this.$refs.saveDetailInfoForm.validate();

      if (
        this.searchedAhomeAddressNationalName != null &&
        this.searchedAhomeAddressNationalName != "" &&
        this.searchedAofficeAddressNationalName != null &&
        this.searchedAofficeAddressNationalName != ""
      ) {
        if (
          this.searchedAhomeAddressNationalName !=
          this.searchedAofficeAddressNationalName
        ) {
          kuaaFnc.showSwal(
            "주소 정보 저장",
            "해외 거주지와 사무실의 국적이 다릅니다."
          );
          return false;
        }
      }

      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "주소 정보를 저장 하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.SAVE_MEMBER_ADDR,
            this.profile,
            "post",
            response => {
              if (response.result) {
                kuaaFnc.showSwal(
                  "주소 정보 저장",
                  "주소 정보가 저장 되었습니다."
                );
                this.resetVewMember(this.profile.memberNo);
                return true;
              } else {
                kuaaFnc.showSwal("주소 정보 저장", response.resultMessage);
                this.resetVewMember(this.profile.memberNo);
                return false;
              }
            }
          );
        }
      });
    },
    activateShowCollegeModal(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.isShowCollegeModal = true;
    },
    activateShowDeptModal(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (this.profile.collegeCd) {
        this.isShowClassModal = true;
      } else {
        kuaaFnc.showSwal("학과 선택 팝업", "대학을 먼저 선택하세요");
      }
    },
    activateShowNationalModal(mode, event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      if (mode) {
        this.nationalModalMode = mode;
      }

      this.isShowNationalModal = true;
    },
    customFormatter(date) {
      let res = date && date != "" ? moment(date).format("YYYYMMDD") : "";
      return res;
    },
    async savePhoto() {
      if (this.photoFile) {
        if (
          this.savedPhotoFileName !== this.photoFile.name ||
          this.savedPhotoFileSize !== this.photoFile.size
        ) {
          let formData = new FormData();
          formData.append("uploadFiles", this.photoFile);
          formData.append("memberNo", this.profile.memberNo);

          await kuaaApi.sendServerMixData(
            URL_CONST.SAVE_PHOTO_FILES,
            formData,
            "post",
            res => {
              if (res.data.success) {
                if (res.data.data[0].fileBaseId) {
                  this.savedImgUrl =
                    URL_CONST.FILE_DOWN_LOAD +
                    "?fileBaseId=" +
                    res.data.data[0].fileBaseId;
                  this.savedFileBaseId = res.data.data[0].fileBaseId;
                  this.photoFileName = res.data.data[0].orgFileNm;
                  this.photoFileSize = res.data.data[0].fileSize;
                }
              } else {
                kuaaFnc.showSwal("Profile Photo Save", res.data.resultMessage);
              }
            }
          );
        }
      }
    },
    getBranchMemberList(type) {
      let params = { memberNo: this.currentMemberNo };
      if (type == 2) {
        params["branchGb"] = "Z";
      }
      kuaaApi.sendServer(
        URL_CONST.GET_BRANCH_MEMBER_LIST,
        params,
        "post",
        response => {
          if (type == 1) {
            this.branchMemberList = response.data.data.contents;
          } else {
            this.branchZMemberList = response.data.data.contents;
          }
          // if(response.data.data.contents.lenght > 0 ){
          // 	this.profile.workhisGb = response.data.data.contents[0].workHisGb;
          // }
        }
      );
    },

    searchMemberInfoByNo(e) {
      e.stopPropagation();
      e.preventDefault();
      let regex = RegExp(/^[a-zA-Z0-9]*$/);
      if (
        this.profile.memberNo.length < 8 ||
        !regex.test(this.profile.memberNo)
      ) {
        Swal.fire(
          kuaaFnc.getSwalModaloptions({
            html: "교우번호를 정확히 입력 하세요."
          })
        );
        return;
      }
      this.campaignMemberChange(this.profile.memberNo);
    },

    campaignMemberChange(memberNo) {
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        { memberNo: memberNo.trim(), printingGb: "Y" },
        "post",
        response => {
          if (response.data.result) {
            if (!response.data.data.contents[0]) {
              kuaaFnc.showSwal(
                "교우 조회",
                "교우[" + memberNo + "]의 유효한 정보가 존재하지 않습니다."
              );
            } else {
              this.profile = response.data.data.contents[0];
              this.memberModalMode = "profile";
              this.onSelectedModalMember(response.data.data.contents[0]);
            }
          }
        }
      );
    },
    clearwork() {
      this.companyNm = "";
      this.profile.companyId = "";
      this.profile.companyNm = "";
      this.profile.workCd1 = "";
      this.profile.workCd1Nm = "";
      this.profile.workCd2 = "";
      this.profile.workCd2Nm = "";

      this.profile.partNm = "";
      this.profile.levelNm = "";
      this.profile.positionNm = "";
    },
    clearWorkAddress() {
      this.profile.officeZipcd = null;
      this.profile.officeStatus = null;
      this.profile.officeAddressDeny = null;
      this.profile.officeAddress1 = null;
      this.profile.officeAddress2 = null;
      this.profile.officeTel = null;
      this.profile.officeFax = null;
    },
    clearAddress() {
      this.profile.homeStatus = null;
      this.profile.homeAddressDeny = null;
      this.profile.homeGb = null;
      this.profile.homeZipcd = null;
      this.profile.homeAddress1 = null;
      this.profile.homeAddress2 = null;
      this.profile.homeTel = null;
      this.profile.homeFax = null;
    },
    resignation() {
      if (!this.profile.memberNo) {
        kuaaFnc.showSwal("퇴사 처리", "교우를 먼저 선택후 진행해 주세요");
        return false;
      }

      if (!this.profile.companyNm) {
        kuaaFnc.showSwal("퇴사 처리", "등록된 직장이 없습니다.");
        return false;
      }

      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "퇴사 처리 하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.SAVE_RESIGN,
            {
              memberNo: this.profile.memberNo,
              companyNm: this.profile.companyNm
            },
            "post",
            response => {
              kuaaFnc.showSwal("퇴사 처리", "퇴사 처리 되었습니다.");
              this.resetVewMember(this.profile.memberNo);
              return true;
            }
          );
        }
      });
    },

    setSms() {
      if (!this.profile.cellular || this.profile.cellular == "") {
        Swal.fire(
          kuaaFnc.getSwalModaloptions({ html: "휴대폰 정보가 없습니다." })
        );
        return;
      }
      this.smsData["Phone"] = this.profile.cellular;
      this.smsData["Subject"] = "";
      this.smsData["Main_Text"] = "";
      this.smsData["Service"] = "SMS";
      this.showSmsModal = true;
    },

    sendSms() {
      let apiparams = {
        UserID: "kuaa1905",
        UserPW: "kou1905!",
        Service: this.smsData.Service,
        Type: "Send",
        Subject: this.smsData.Subject,
        Callback: "15881905",
        Main_Text: this.smsData.Main_Text,
        Destination:
          '[{"Company": "고려대학교교우회","Name": "' +
          this.profile.memberHnm +
          '","Phone": "' +
          this.smsData.Phone +
          '"}]'
      };

      kuaaApi.sendServer3(
        "https://balsong.com/Linkage/API/",
        apiparams,
        "post"
      );

      this.smsData.Subject = "";
      this.smsData.Main_Text = "";

      this.showSmsModal = false;
    },

    resetData() {
      this.profile = {
        memberNo: "", // 교우번호
        memberHnm: "", // 교우명(한글)
        memberCnm: "", // 교우명(한자)
        memberEnm: "", // 교우명(영문)
        prevNm: "", // 개명 전
        enterYm: "", // 입학년월
        graduationYm: "", // 졸업년월
        hakbun: "", // 학번
        graduationNo: "0", // 졸업횟수
        collegeCd: "", // 대학코드
        classCd: "", // 학과코드
        sex: "", // 성별
        birthday: "", // 생일
        birthGb: "", // 1 : 음력, 2 : 양력
        weddingGb: "", // Y : 기혼, N : 미혼
        weddingday: "", // 결혼기념일
        nationalCd: "", // 국적
        registerNo: "", // 등록번호(주민번호)
        cellular: "", // 휴대전화
        cellularDeny: "", // 휴대전화 수신거부
        secretary: "", // 상임이사중 연회비 납부여부
        secretaryTel: "", // 비서연락처
        eMail: "", // 이메일
        eMailDeny: "", // 이메일 수신거부
        eMail2: "", // 이메일2
        eMail2Deny: "", // 이메일2 수신거부
        homepage: "", // 홈페이지
        webid: "", // 웹아이디
        webpass: "", // 웹패스워드
        postplace: "", // 우편물발송지
        nonpostGb: "", // 미발송구분
        status: "", // 1 : 정상, 2 : 작고
        memberGb: "", // Y : 평생회원, N : 평생회원 아님
        memberorgGb: "", // ?? : 임원진직위코드, 00 : 직위없음
        memberorgGbNm: "", // ?? : 임원진직위코드, 00 : 직위없음
        memberjbGb: "", // JN : 지부, NB : 분회, JB : 지부/분회, NN : ??
        lastFeeDate: "", // 최종회비납입일
        lastFeeYear: "", // 최종회비납입년도
        highschool: "", // 출신고교
        remark: "", // 설명
        staffCd: "", // 스텝코드
        confirmGb: "", // Y : 검증됨, N : 검증안됨
        joinDate: "", // 입사일
        companyId: "", // 직장코드
        companyNm: "", // 직장명
        levelNm: "", // 직위
        partNm: "", // 부서
        positionNm: "", // 직책
        homeGb: "", // 0 : 구주소, 1 : 도로명주소
        homeZipcd: "", // 자택우편번호
        homeAddress1: "", // 주소1
        homeAddress2: "", // 주소2
        homeAddress3: "", // 도로명 주소1
        homeAddress4: "", // 도로명 주소2
        homeAddressDeny: "", // 자택주소 수신거부
        homeTel: "", // 전화번호
        homeFax: "", // 팩스번호
        homeStatus: "", // Y : YES, N : NO
        officeGb: "", // 0 : 구주소, 1 : 도로명주소
        officeZipcd: "", // 직장우편번호
        officeAddress1: "", // 직장주소1
        officeAddress2: "", // 직장주소2
        officeAddress3: "", // 직장 도로명 주소1
        officeAddress4: "", // 직장 도로명 주소2
        officeAddressDeny: "", // 직장 주소 수신거부
        officeTel: "", // 대표전화번호
        officeDirect: "", // 직통전화번호
        officeInner: "", // 내선번호
        officeFax: "", // 사무실 팩스
        officeStatus: "", // Y : YES, N : NO
        anationalCd: "", // 국외 국가코드
        ahomeGb: "", // 0 : 구주소, 1 : 도로명주소
        ahomeAddress1: "", // 국외주소1
        ahomeAddress2: "", // 국외주소2
        ahomeAddress3: "", // 국외주소3
        ahomeAddressDeny: "", // 국외주소 수신거부
        ahomeTel: "", // 국외전화번호
        ahomeFax: "", // 국외팩스번호
        aofficeAddress1: "", // 국외직장주소1
        aofficeAddress2: "", // 국외직장주소2
        aofficeAddress3: "", // 국외직장주소3
        aofficeAddressDeny: "", // 국외직장주소 수신거부
        aofficeTel: "", // 국외직장전화번호
        aofficeFax: "", // 국외직장팩스번호
        aofficeStatus: "", // Y : YES, N : NO
        insertDate: "", // 입력일시
        updateDate: "", // 변경일시
        addrUpdateDate: "", //주소변경일시
        hUpdateDate: "", // 국내주소변경일시
        oUpdateDate: "", // 국내사무실변경일시
        ahUpdateDate: "", // 해외거주지변경일시
        aoUpdateDate: "", // 해외사무실변경일시
        userNo: "",
        mlevelCd: "",
        seqNo: "", // tb_scholar key
        workCd1: "",
        workCd2: "",
        workCd1Nm: "",
        workCd2Nm: "",
        bornCd: null,
        workhisGb: "",
        ahomeStatus: ""
      };
      this.photoFile = null;
      this.photoFileName = null;
      this.photoFileSize = null;
      this.savedImgUrl = null;
      this.savedFileBaseId = null;
    }
  }
};
</script>
<style lang="scss" scoped>
/*.modal-footer {
  align-items: center;
  justify-content: center;
}

.modal-footer .md-button:not(:last-child) {
  margin-right: 3px;
}*/
.md-card .photo-frame {
  height: 129px;
  background-size: contain;
}
.md-card .photo-ui {
  margin-top: -35px;
}
.remark-input {
  height: 70px;
  width: 100%;
}
.margin-0 {
  margin: 0;
}
.total-line {
  height: 40px;
  background-color: #d6eef5;
  line-height: 40px;

  &.left-type {
    padding-left: 19%;
  }
  &.right-type {
    text-align: right;
    padding-right: 13%;
  }
  > span {
    display: inline-block;
    padding: 0 10px;

    &.total-label {
    }
  }
}
.tab-area {
  height: 40px;
}
.md-button:not(.md-just-icon):not(.md-btn-fab):not(.md-icon-button):not(.md-toolbar-toggle)
  .md-ripple {
  padding: 15px 30px;
}
.branch-list {
  line-height: 18px;
  height: 54px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.branch-list2 .item {
  display: inline-block;
  width: 33%;
  box-sizing: border-box;
  padding-left: 5px;
}
.branch-list2 .branch-list-con {
  position: relative;
}
.branch-list2 .branch-list-con:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 33%;
  width: 1px;
  height: 100%;
  background: #ccc;
}
.branch-list2 .branch-list-con:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 66%;
  width: 1px;
  height: 100%;
  background: #ccc;
}
</style>
